module.exports = __webpack_public_path__ + "img/網球、女網.af12c51f.jpg";